import React, { useState } from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import CoverImg from "../Assets/CoverImg.png";
import TeamImg from "../Assets/TeamProfile.png";
import { ReactComponent as CameraIcon } from "../Assets/Icons/cameraIcon.svg";
import StateIcon from "../Assets/Icons/stateIcon.svg";
import ProjectTypeIcon from "../Assets/Icons/projectIcon.svg";
import MatchIcon from "../Assets/Icons/matchIcon.svg";
import TaskIcon from "../Assets/Icons/taskIcon.svg";
import PenIcon from "../Assets/Icons/panIcon.svg";
import EyeIcon from "../Assets/Icons/eyeBlack.svg";
import ShareIcon from "../Assets/Icons/shareIcon.svg";
import PlusIcon from "../Assets/Icons/plusIcon.svg";
import TeamMemberCard from "../Components/AITeam/TeamMemberCard";
import PeopleAvatar from "../Assets/PeopleAvatar.png";
import CompanyAvatar from "../Assets/CompanyAvatar.png";
import PreviousProject from "../Components/AITeam/PreviousProject";
import ProjectImg from "../Assets/ProjectImg.png";
import Tags from "../Components/AITeam/Tags";
import CloseIcon from "../Assets/Icons/closeIcon.svg";
import TagsImg from "../Assets/Icons/financialIcon.svg";
import UniIcon from "../Assets/UniAvatar.png";
import UniversalCard from "../Components/AITeam/UniversalCard";
import FrameWorkIcon from "../Assets/FrameworkAvatar.png";
import AiTeamModal from "../Components/AiTeamModal";
import ShareTeamProfileModal from "../Components/ShareTeamProfileModal";
import AiTeamSideBar from "../Components/AITeam/AiTeamSideBar";
import SqlIcon from "../Assets/sql.png";
import RIcon from "../Assets/rIcon.png";
import SparkIcon from "../Assets/spark.png";
import PyTorch from "../Assets/pytorchIcon.png";
import HtmlIcon from "../Assets/HTML Daimlas.png";
import CssIcon from "../Assets/CSS Daimlas.png";
import AngularIcon from "../Assets/Angular Daimlas.png";
import BootstrapIcon from "../Assets/Bootstrap Daimlas.png";
import JavaIcon from "../Assets/Java Daimlas.png";
import NodeIcon from "../Assets/Node Daimlas.png";
import PythonIcon from "../Assets/Python Daimlas.png";
import RedisIcon from "../Assets/Redis Daimlas.png";
import MIcrosoftSql from "../Assets/Microsoft SQL Server Daimlas.png";
import MonogoDb from "../Assets/MongoDB Daimlas.png";
import MySqlIcon from "../Assets/MySQL Daimlas.png";
import NeoIcon from "../Assets/Neo4j Daimlas.png";
import DockerIcon from "../Assets/Docker Daimlas.png";
import AzureIcon from "../Assets/Azure Daimlas.png";
import ChefIcon from "../Assets/Chef Daimlas.png";
import BladeIcon from "../Assets/Bladecenter Daimlas.png";
import KotlinIcon from "../Assets/Kotlin Daimlas.png";
import SwiftIcon from "../Assets/Swift Daimlas.png";
import PwaIcon from "../Assets/PWA Daimlas.png";
import ObjectiveC from "../Assets/Objective-C Daimlas.png";
import IndustryIcon from "../Assets/IndustryIcon.png";
import IndustryIconTwo from "../Assets/IndustryIcon1.png";
import IndustryIconThree from "../Assets/IndustryIcon2.png";
import IndustryIconFour from "../Assets/IndustryIcon3.png";
import IndustryIconFive from "../Assets/Biology, Health and Medicine.png";
import IndustryIconSix from "../Assets/Business Analysis.png";
import IndustryIconSeven from "../Assets/Business Process Redesign.png";
import IndustryIconEight from "../Assets/Change Management.png";
import industryIconNine from "../Assets/Brand _ Marketing Strategy.png";
import IndustrialIconTen from "../Assets/4_Chinchilla.png";
import IndustrialIconEleven from "../Assets/4_GPT-3.png";
import IndustrialIconTwelve from "../Assets/4_GPT-4.png";
import IndustrialIconThirteen from "../Assets/4_Claude.png";
import IndustrialIconFourteen from "../Assets/Analytics.png";
import IndustrialIconFifteen from "../Assets/Blockchain.png";
import IndustrialIconSixteen from "../Assets/Business Intelligence.png";
import IndustrialIconSeventeen from "../Assets/Data Engineering.png";
import IndustrialIconEighteen from "../Assets/CRM, ERP, Accounting, Operations, Marketing Automation.png";
import RoboticIcon from "../Assets/Robotic Process Automation (RPA).png";
import BigDataIcon from "../Assets/Big Data and Cloud.png";
import BlockchainIcon from "../Assets/Blockchain Technologies.png";
import BusinessIcon from "../Assets/Business Intelligence and Visualization.png";
import ChatbotIcon from "../Assets/Chatbot and Voice Assistant.png";
import ComplexCodeIcon from "../Assets/Daimlas Complex Code Bases.png";
import ComputerScienceIcon from "../Assets/Daimlas Computer Science Fundamentals.png";
import DataStructureIcon from "../Assets/Daimlas Data Structures.png";
import DeepLearningIcon from "../Assets/Daimlas Deep Learning Frameworks.png";
import LargeSystemsIcon from "../Assets/Daimlas Large Systems.png";
import DevOpsIcon from "../Assets/Daimlas Dev Ops.png";
import FrontEndIcon from "../Assets/Daimlas Front End.png";
import FullStackIcon from "../Assets/Daimlas Full Stack.png";
import MlOpsIcon from "../Assets/Daimlas ML Ops.png";
import MobileIcon from "../Assets/Daimlas Mobile.png";
import IndustrialIconNineteen from "../Assets/Matplotlib Daimlas.png";
import IndustrialIconTwenteen from "../Assets/NLTK Daimlas.png";
import IndustrialIconTwentyOne from "../Assets/NumPy Daimlas.png";
import IndustrialIconTwentyTwo from "../Assets/Pandas Daimlas.png";
import IndustrialIconTwentyThree from "../Assets/Amazon SageMaker Daimlas.png";
import IndustrialIconTwentyFour from "../Assets/DataRobot Daimlas.png";
import IndustrialIconTwentyFive from "../Assets/Looker Daimlas.png";
import IndustrialIconTwentySix from "../Assets/Google Cloud Daimlas.png";

export default function AiTeamPreview() {
  return (
    <div>
      <DashboardLayout>
        <section className="bg-white py-4 px-6 gap-y-5 w-full flex flex-col items-start">
          <Breadcrumbs links={[{ name: "Team Profile", link: "dsads" }]} />
          <div className="w-full">
            <div
              style={{ backgroundImage: `url(${CoverImg})` }}
              className="w-full h-[22rem] bg-no-repeat bg-cover rounded-[8px] flex items-start justify-end p-3"
            >
              <CameraIcon stroke="black" />
            </div>
            <div className="flex items-center justify-center mt-[-70px]">
              <div
                style={{ backgroundImage: `url(${TeamImg})` }}
                className="w-[10rem] h-[10.1rem] bg-no-repeat bg-cover flex items-center justify-center pt-36 p-3 rounded-full">
                <CameraIcon stroke="white" />
              </div>
            </div>
            <div className="flex items-center flex-col justify-center gap-[5px] MT-3">
              <p className="text-[1.25rem] text-[#111928] font-bold">
                Al in Workforce Development Team
              </p>
              <p className="text-[1rem] text-[#6B7280]">Riyadh</p>
              <p className="text-[1rem] text-[#942A27]">
                Assigned Al Project <span className="text-[#6B7280]">:</span>{" "}
                First AI Project
              </p>
              <p className="text-[0.875rem] text-[#6B7280]">
                Joined Since: July 15, 2022
              </p>
            </div>
            {/* <div className="flex items-center justify-center gap-4 mt-5">
              <button className="bg-[#E5E7EB] w-[9.4rem] py-2 text-[0.94rem] text-[#1F2A37] font-[500] rounded-[8px] flex items-center justify-center gap-2">
                <img src={ProjectTypeIcon} /> Al Projects
              </button>
              <button className="bg-[#E5E7EB] w-[9.4rem] py-2 text-[0.94rem] text-[#1F2A37] font-[500] rounded-[8px] flex items-center justify-center gap-2">
                <img src={TaskIcon} /> My Tasks
              </button>
              <button
                className="bg-[#E5E7EB] w-[9.4rem] py-2 text-[0.94rem] text-[#1F2A37] font-[500] rounded-[8px] flex items-center justify-center gap-2"
                onClick={() => setOpenModal(true)}
              >
                <img src={PenIcon} /> Edit Profile
              </button>
              <button className="bg-[#E5E7EB] w-[9.4rem] py-2 text-[0.94rem] text-[#1F2A37] font-[500] rounded-[8px] flex items-center justify-center gap-2">
                <img src={EyeIcon} /> Preview Profile
              </button>
            </div> */}
          </div>
        </section>
        <section className="bg-[#F9FAFB] py-4 px-6 gap-y-5 w-full flex items-start justify-between">
          <section className="w-[67%] py-4">
            <div>
              <p className="text-[1rem] text-[#101828]">Team Members</p>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="grid grid-cols-3 gap-4 mt-6">
              {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((keys) => {
                return (
                  <TeamMemberCard
                    img={PeopleAvatar}
                    name="Roberta Casas"
                    position="Data Scientist"
                    btntext="View Profile"
                    hourstext="Hours Available This Week:"
                    hours="40"
                  />
                );
              })}
            </div>
            <div className="mt-12">
              <p className="text-[1rem] text-[#101828]">Companies worked for</p>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center justify-between flex-wrap gap-4 mt-6">
              {[0, 1, 2].map((keys) => {
                return (
                  <TeamMemberCard
                    img={CompanyAvatar}
                    name="Active.ai"
                    location="Singapore"
                  />
                );
              })}
            </div>
            <div className="mt-12">
              <p className="text-[1rem] text-[#101828]">Previous Projects</p>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center justify-between flex-wrap gap-4 mt-6">
              {[0, 1].map((keys) => {
                return (
                  <PreviousProject
                    projectimg={ProjectImg}
                    projecttitle="Project Title"
                    location="Riyadh"
                    desc="Mobile banking apps and web portals, financial service AI can analyze consumers’ individual account data to see what they have, how they’re performing financially, make recommendations on future actions based on the results, and then help with automation for savings and budgeting for better financial health and behavior."
                  />
                );
              })}
            </div>
            <div className="mt-12">
              <p className="text-[1rem] text-[#101828]">
                Subject Matter Experts
              </p>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center justify-between flex-wrap gap-4 mt-6">
              {[0, 1, 2].map((keys) => {
                return (
                  <TeamMemberCard
                    img={PeopleAvatar}
                    name="John T"
                    location="New Jersey"
                    position="Data scientist"
                    btntext="View Profile"
                  />
                );
              })}
            </div>
            <div className="mt-12">
              <p className="text-[1rem] text-[#101828]">Industry</p>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center flex-wrap gap-3 mt-6">
              <Tags tagsimg={IndustryIcon} tagstext="Aerospace" />
              <Tags tagsimg={IndustryIconTwo} tagstext="Agriculture" />
              <Tags
                tagsimg={IndustryIconFour}
                tagstext="Chemical, oil and gas"
              />
              <Tags tagsimg={IndustryIconThree} tagstext="Automotive" />
              <Tags tagsimg={TagsImg} tagstext="Energy and Utility" />
            </div>
            <div className="mt-12">
              <p className="text-[1rem] text-[#101828]">
                Specialization and Business Function
              </p>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center flex-wrap gap-3 mt-6">
              <Tags
                tagsimg={IndustryIconFive}
                tagstext="Biology, Health and Medicine"
              />
              <Tags tagsimg={IndustryIconSix} tagstext="Business Analysis" />
              <Tags
                tagsimg={IndustryIconSeven}
                tagstext="Business Process Redesign"
              />
              <Tags tagsimg={IndustryIconEight} tagstext="Change Mangement" />
              <Tags
                tagsimg={industryIconNine}
                tagstext="Brand Marketing Strategy"
              />
            </div>
            <div className="mt-12">
              <p className="text-[1rem] text-[#101828]">
                Foundational Models / LLM's
              </p>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center flex-wrap gap-3 mt-6">
              <Tags tagsimg={IndustrialIconTen} tagstext="Chinchilla" />
              <Tags tagsimg={IndustrialIconEleven} tagstext="GPT-3" />
              <Tags tagsimg={IndustrialIconTwelve} tagstext="GPT-4" />
              <Tags tagsimg={IndustrialIconThirteen} tagstext="Claude" />
            </div>
            <div className="mt-12">
              <p className="text-[1rem] text-[#101828]">Technical Function</p>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center flex-wrap gap-3 mt-6">
              <Tags tagsimg={IndustrialIconFourteen} tagstext="Analytics" />
              <Tags
                tagsimg={IndustrialIconSixteen}
                tagstext="Business Intelligence"
              />
              <Tags
                tagsimg={IndustrialIconSeventeen}
                tagstext="Data Engineering"
              />
              <Tags tagsimg={IndustrialIconEighteen} tagstext="CRM" />
              <Tags tagsimg={IndustrialIconFifteen} tagstext="Blockchain" />
            </div>
            <div className="mt-12">
              <p className="text-[1rem] text-[#101828]">Technology and Tools</p>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center flex-wrap gap-3 mt-6">
              {[
                {
                  name: "Big Data",
                  icon: BigDataIcon,
                },
                {
                  name: "Blockchain",
                  icon: BlockchainIcon,
                },
                {
                  name: "Business Intelligence",
                  icon: BusinessIcon,
                },
                {
                  name: "Chatbot",
                  icon: ChatbotIcon,
                },
                {
                  name: "Robotic Process Automation",
                  icon: RoboticIcon,
                },
              ].map((item) => {
                return <Tags tagsimg={item.icon} tagstext={item.name} />;
              })}
            </div>
            <div className="mt-12">
              <p className="text-[1rem] text-[#101828]">Deep Understanding</p>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center flex-wrap gap-3 mt-6">
              {[
                {
                  name: "Complex Code Bases",
                  icon: ComplexCodeIcon,
                },
                {
                  name: "Computer Science Fundamentals",
                  icon: ComputerScienceIcon,
                },
                {
                  name: "Data Structures",
                  icon: DataStructureIcon,
                },
                {
                  name: "Deep Learning Frameworks",
                  icon: DeepLearningIcon,
                },
                {
                  name: "Large Systems",
                  icon: LargeSystemsIcon,
                },
              ].map((item) => {
                return <Tags tagsimg={item.icon} tagstext={item.name} />;
              })}
            </div>
            <div className="mt-12">
              <p className="text-[1rem] text-[#101828]">Based on Roles</p>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center flex-wrap gap-3 mt-6">
              {[
                {
                  name: "Dev Ops",
                  icon: DevOpsIcon,
                },
                {
                  name: "Front End",
                  icon: FrontEndIcon,
                },
                {
                  name: "Full Stack",
                  icon: FullStackIcon,
                },
                {
                  name: "ML Ops",
                  icon: MlOpsIcon,
                },
                {
                  name: "Mobile",
                  icon: MobileIcon,
                },
              ].map((item) => {
                return <Tags tagsimg={item.icon} tagstext={item.name} />;
              })}
            </div>
            {/* <div className="flex items-center justify-between  mt-12">
            <p className="text-[1rem] text-[#101828]">Applied Statistics</p>
            <div className="flex items-center gap-2">
              <img src={PlusIcon} />
              <p className="text-[#942A27]">Add applied statistics</p>
            </div>
          </div> */}
            {/* <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
          <div className="flex items-center flex-wrap gap-3 mt-6">
            {[0, 1, 2, 3, 4].map((keys) => {
              return (
                <Tags
                  
                  tagsimg={TagsImg}
                  tagstext="Energy and Utility"
                />
              );
            })}
          </div> */}
          </section>
          <section className="w-[30%] py-4 ">
            {/* <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px]">
            <p>Team Members Schools</p>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
            <div className="flex flex-col gap-3 mt-3">
              {[0, 1, 2, 3].map((keys) => {
                return (
                  <UniversalCard
                    img={UniIcon}
                    name="University of Tennessee"
                    location="Nashville, TN, USA"
                    
                    
                  />
                );
              })}
            </div>
            <div className="mt-3">
              <button className="w-full py-2 rounded-[8px] border-[1px] border-dashed border-[#9CA3AF] text-[0.94rem] font-[500] text-[#1F2A37]">
                Add education
              </button>
            </div>
          </div> */}
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>Machine Learning Frameworks</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={SparkIcon}
                  name="Spark"
                  width="22px"
                  height="11px"
                />
                <UniversalCard
                  img={RIcon}
                  name="R Prokject"
                  width="22px"
                  height="15px"
                />
                <UniversalCard
                  img={PyTorch}
                  name="Pytorch"
                  width="22px"
                  height="8px"
                />
                <UniversalCard
                  img={SqlIcon}
                  name="Sql"
                  width="15px"
                  height="20px"
                />
              </div>
            </div>
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>Front End</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={HtmlIcon}
                  name="HTML"
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={CssIcon}
                  name="CSS"
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={BootstrapIcon}
                  name="Bootstrap"
                  width="18px"
                  height="20px"
                />
                <UniversalCard
                  img={AngularIcon}
                  name="Angular"
                  width="18px"
                  height="20px"
                />
              </div>
            </div>
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>Back End</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={PythonIcon}
                  name="Python"
                  width="17px"
                  height="17px"
                />
                <UniversalCard
                  img={JavaIcon}
                  name="Java"
                  width="17px"
                  height="17px"
                />
                <UniversalCard
                  img={NodeIcon}
                  name="NodeJs"
                  width="17px"
                  height="17px"
                />
                <UniversalCard
                  img={RedisIcon}
                  name="Redis"
                  width="17px"
                  height="17px"
                />
              </div>
            </div>
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>Database</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={MonogoDb}
                  name="MongoDB"
                  width="16px"
                  height="16px"
                />
                <UniversalCard
                  img={NeoIcon}
                  name="Neo"
                  width="16px"
                  height="16px"
                />
                <UniversalCard
                  img={MySqlIcon}
                  name="MySQL"
                  width="16px"
                  height="16px"
                />
                <UniversalCard
                  img={MIcrosoftSql}
                  name="Microsoft SQL"
                  width="18px"
                  height="18px"
                />
              </div>
            </div>
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>DevOps</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={DockerIcon}
                  name="Docker"
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={ChefIcon}
                  name="Chef"
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={AzureIcon}
                  name="Azure"
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={BladeIcon}
                  name="IBM"
                  width="20px"
                  height="20px"
                />
              </div>
            </div>
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>Mobile App</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={KotlinIcon}
                  name="Kotlin"
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={ObjectiveC}
                  name="ObjectiveC"
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={PwaIcon}
                  name="PWA"
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={SwiftIcon}
                  name="Swift"
                  width="20px"
                  height="20px"
                />
              </div>
            </div>
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>Data Science Toolkits</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={IndustrialIconNineteen}
                  name="Matplotlib"
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={IndustrialIconTwenteen}
                  name="Natural Language Toolkit"
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={IndustrialIconTwentyOne}
                  name="NumPy"
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={IndustrialIconTwentyTwo}
                  name="Pandas"
                  width="20px"
                  height="20px"
                />
              </div>
            </div>
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>Cloud Vendor Experience</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={IndustrialIconTwentyThree}
                  name="Amazon SageMaker"
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={IndustrialIconTwentyFour}
                  name="DataRobot"
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={IndustrialIconTwentyFive}
                  name="Looker"
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={IndustrialIconTwentySix}
                  name="Google Cloud"
                  width="20px"
                  height="20px"
                />
              </div>
            </div>
          </section>
        </section>
      </DashboardLayout>
    </div>
  );
}
